import hasDocumentSelection from './hasDocumentSelection';
export default hasDocumentSelection;